<template>
  <b-modal
      id="1"
      :title="title"
      v-model="isOpenLocal"
      size="lg"
      scrollable
      :hide-footer="hideFooter"
      :ok-title="capitalize($t('validate'))"
      :cancel-title="capitalize($t('cancel'))"
      @hide="tryCloseOutgoingInvoiceModal"
      @hidden="handleCancel"
      @ok="handleOk"
  >
    <validation-observer
        ref="observerRef"
        #default="{handleSubmit, errors}">
      <b-form @submit.prevent="handleSubmit(submitValidatedOutgoingInvoiceLocal)">
        <form-outgoing-invoice :invoice="outgoingInvoice"
                               :formErrors="errors"/>
        <button ref="submitOutgoingInvoiceFormRef"
                class="d-none"></button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'
import { capitalize } from '../../utils/filter'

import useAPI from '../../utils/useAPI'
import FormOutgoingInvoice from '../form/outgoingInvoice/OutgoingInvoice'

export default {
  components: {
    ValidationObserver,
    FormOutgoingInvoice
  },
  props: {
    outgoingInvoice: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const isOpenLocal = ref(false)
    const outgoingInvoiceLocal = ref(props.outgoingInvoice)
    const submitOutgoingInvoiceFormRef = ref(null)
    const observerRef = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { currentBreakPoint } = useAPI()

    const hideFooter = computed(() => {
      return !['xs', 'sm'].includes(currentBreakPoint.value)
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(isOpenLocal, (val) => {
      emit('update:isOpen', val)
    })
    watch(outgoingInvoiceLocal, (val) => {
      emit('update:outgoingInvoice', val)
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const tryCloseOutgoingInvoiceModal = (modalEvent) => {
      if (modalEvent.trigger == 'backdrop') {
        // Click outside
        modalEvent.preventDefault()
        submitOutgoingInvoiceFormRef.value.click()
      }
    }

    const submitValidatedOutgoingInvoiceLocal = () => {
      emit('submitValidatedOutgoingInvoice')
    }

    const handleOk = async (bvModalEvent) => {
      bvModalEvent.preventDefault()

      const isValid = await observerRef.value.validate()
      if (isValid) {
        submitValidatedOutgoingInvoiceLocal()
      }
    }

    const handleCancel = () => {}

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,

      // Data
      isOpenLocal,
      outgoingInvoiceLocal,
      submitOutgoingInvoiceFormRef,
      observerRef,

      // Computed
      hideFooter,

      // Methods
      tryCloseOutgoingInvoiceModal,
      submitValidatedOutgoingInvoiceLocal,
      handleOk,
      handleCancel,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    outgoingInvoice: function (val) {
      this.outgoingInvoiceLocal = val
    },
    isOpen: function (val) {
      this.isOpenLocal = val
    }
  },
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>